/**
 * Send data to Firebase Analytics via cordova firebasex plugin
 *
 * @author dgm11b
 */
export const fireAnalyticsSetup = () => {


    const swListener = (toggle) => {

        if(toggle === 'add'){
            //sw-option elements added dynamically so need generic event listener for all clicks
            document.addEventListener("click", swOptionCallback)
        } else if (toggle === 'remove') {
            document.removeEventListener("click", swOptionCallback)
        }

    }

    //Callback for swListener
    const swOptionCallback = (event) => { 
        //If the element clicked contains the class 'sw-option'
        if(event.target.classList.contains('sw-option')){
            //Check if cordova
            if (window.cordova) {
                //Send firebase analytics
                window.FirebasePlugin.logEvent("sw_option_selected", { sw_option: event.target.getAttribute('handle')});
            }
        }
    }

    const outboundListener = () => {
        document.addEventListener("click", outboundCallback)
    }

     //Callback for outboundListener
     const outboundCallback = (event) => { 
        //If the element clicked contains the class 'sw-option'
        if(event.target.nodeName === 'A'){
            //Check if cordova
            if (window.cordova) {
                //Set up properties
                let linkClasses = [...event.target.classList].join(' ')
                let linkID = event.target.id
                let linkDomain = event.target.hostname

                //Check outbound link or not
                let linkURL = event.target.href;
                let isOutbound = false;
                if(!linkURL.startsWith('https://gla.ac.uk') && !linkURL.startsWith('https://www.gla.ac.uk')) {
                    isOutbound = true;
                }

                //Send Firebase analytics
                window.FirebasePlugin.logEvent("click", 
                    { 
                        link_url: linkURL,
                        outbound: isOutbound,
                        link_id: linkID,
                        link_classes: linkClasses,
                        link_domain: linkDomain
                    }
                );
            }
        }
    }

    const mapFeaturesListener = (toggle) => {
        //Add/remove click event listener to the map feature apply button
        const applyButton = document.querySelector('#featuresContainer #applyFeatures')

        if(toggle === 'add'){
            applyButton.addEventListener("click", mapFeaturesCallback)
        } else if (toggle === 'remove') {
            applyButton.removeEventListener("click", mapFeaturesCallback)
        }

    }

    //Callback for mapFeaturesListener
    const mapFeaturesCallback = () => { 
            //Check if cordova
            if (window.cordova) {
                //Get selected features
                var featureSelected = document.querySelectorAll('.featureButton.selected span');

                // Safety: if nothing selected, do nothing
                if (!featureSelected || !featureSelected.length) return;

                featureSelected.forEach(
                    (featureBtn) => {
                        //Get the feature button text
                        var featureName = featureBtn.innerText

                        //Send firebase analytics
                        window.FirebasePlugin.logEvent("map_feature_selected", { map_feature_name: featureName});
                });
            }
        }


    return {
        swListener,
        outboundListener,
        mapFeaturesListener
    }

}
